export const BANNER_KEY = ["banner"];
